import "core-js/modules/es6.object.assign";
import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.regexp.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import certificationCom from '@/view/user/certification';
import { common } from '@/api/api_url.js';
import { deepcopy } from '@/libs/util.js';
import editUser from './editUser.vue';
import forgot from '_c/login-form/forgot.vue';
import qiyename from '@/assets/images/qiyename.png';
import upgradeUser from './upgradeUser/upgradeUser';
import { mapActions } from 'vuex';
export default {
  name: "ownspace",
  data: function data() {
    var _this2 = this;

    var validePhone = function validePhone(rule, value, callback) {
      var re = /^1[0-9]{10}$/;

      if (!re.test(value)) {
        callback(new Error(_this2.$t('loginArea.mobilenotice')));
      } else {
        callback();
      }
    };

    return {
      upgradeTitle: this.$t('base.updateAccount'),
      showqiyename: qiyename,
      authenticationStatus: {
        0: this.$t('base.noRealName'),
        1: this.$t('base.realNameAuth'),
        2: this.$t('base.RealNameSuccess'),
        3: this.$t('base.RealNamefail')
      },
      visible: false,
      config: [],
      save_loading: false,
      editPasswordModal: false,
      // 编辑密码模态框显示
      savePassLoading: false,
      userInfo: {
        admin_name: "",
        admin_id: "",
        authentication: "",
        //是否认证
        account_type: "",
        //账号类型
        mobile_phone: "",
        area: [],
        address: "",
        email: "",
        area_name: '',
        enterprise_name_en: '',
        enterprise_name_cn: '',
        enterprise_code: ''
      },
      editMessage: {
        address: '',
        area: '',
        email: '',
        mobile_phone: '',
        enterprise_name_en: '',
        enterprise_name_cn: '',
        enterprise_code: ''
      },
      TreeData: [],
      userInfoValidate: {
        enterprise_code: [{
          required: true,
          validator: function validator(rule, value, callback) {
            var myreg = /^[A-Z0-9]{6}$/,
                data = _this2.userInfo.enterprise_code;

            if (!data) {
              callback(new Error('请输入企业编码'));
            } else if (!myreg.test(data)) {
              callback(new Error('企业编码为6位大字字母和数字'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }, {
          pattern: /^[0-9A-Za-z]{6}$/,
          message: '企业编码为6位字母和数字',
          trigger: 'blur'
        }],
        enterprise_name_cn: [{
          required: true,
          validator: function validator(rule, value, callback) {
            var data = _this2.userInfo.enterprise_name_cn;

            if (!data) {
              callback(new Error('请输入企业名称（中文)'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        enterprise_name_en: [{
          required: true,
          validator: function validator(rule, value, callback) {
            var data = _this2.userInfo.enterprise_name_cn;

            if (!data) {
              callback(new Error('请输入企业名称（英文)'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        mobile_phone: [{
          required: true,
          validator: function validator(rule, value, callback) {
            var myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/,
                data = _this2.userInfo.mobile_phone;

            if (!data) {
              callback(new Error('请输入手机号'));
            } else if (!myreg.test(data)) {
              callback(new Error('手机号格式不对'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        area: [{
          required: true,
          validator: function validator(rule, value, callback) {
            var data = _this2.userInfo.area;

            if (data.length == '0') {
              callback(new Error('请选择区域'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }],
        address: [{
          required: true,
          validator: function validator(rule, value, callback) {
            var data = _this2.userInfo.address;

            if (!data) {
              callback(new Error('街道地址必填'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        email: [{
          required: true,
          validator: function validator(rule, value, callback) {
            var data = _this2.userInfo.email,
                eReg = new RegExp("^[a-z0-9A-Z]+[- | a-z0-9A-Z . _]+@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\\.)+[a-z]{2,}$");

            if (!data) {
              callback(new Error('邮箱必填'));
            } else if (!eReg.test(data)) {
              callback(new Error('不正确的电子邮件格式'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }]
      },
      butDisabled: false,
      enterButton: "获取验证码"
    };
  },
  methods: _objectSpread({}, mapActions(['handleRegister', 'handleForgot']), {
    //判断当前状态
    //实名认证
    certification: function certification(authentication) {
      //判断企业编码是否填写
      if (!this.userInfo.enterprise_code) {
        this.editEnterprise_code('');
      } else {
        var title = this.$t('base.verified');

        if (authentication === 2) {
          title = this.$t('base.viewRealNameAuth');
        } else if (authentication === 3) {
          title = this.$t('base.reAuthentication');
        }

        var vm = this;
        var config = {
          loading: true,
          width: 800,
          render: function render(h) {
            return h('div', [h('h3', {
              style: {
                borderBottom: "1px solid #eee",
                marginBottom: "15px",
                padding: "0 0 10px 0"
              }
            }, title), h(certificationCom, {
              ref: 'certificationCom',
              props: {
                edit: true,
                _vm: vm,
                $store: vm.$store,
                authentication: authentication
              }
            })]);
          },
          onOk: function onOk() {
            var _this = this;

            var obj = this.$refs.certificationCom; //判断是否进行实名认证

            if (obj.statusData.authentication === 0) {
              obj.formCheck().then(function (res) {
                if (res) {
                  //提交请求
                  var formModel = obj.formModel;
                  vm.$store.dispatch("handlereal_name_auth", formModel).then(function (res) {
                    if (res.result === 0) {
                      vm.$Message.success(res.errorMsg);
                      vm.$Modal.remove();
                      vm.init();
                    } else {
                      vm.$Message.error(res.errorMsg);
                      _this.buttonLoading = false;
                    }
                  });
                } else {
                  _this.buttonLoading = false;
                }
              });
            } else {
              vm.$Modal.remove();
            }
          }
        };
        this.$Modal.confirm(config);
      }
    },
    //实名认证中
    certificationIng: function certificationIng(authentication) {
      var _this3 = this;

      //判断企业编码是否填写
      if (!this.userInfo.enterprise_code) {
        this.editEnterprise_code('');
      } else {
        var vm = this;
        var config = {
          loading: true,
          width: 800,
          render: function render(h) {
            return h('div', [h('h3', {
              style: {
                borderBottom: "1px solid #eee",
                marginBottom: "15px",
                padding: "0 0 10px 0"
              }
            }, _this3.$t('base.realNameAuth')), h(certificationCom, {
              ref: 'certificationCom',
              props: {
                edit: true,
                _vm: vm,
                $store: vm.$store,
                authentication: authentication
              }
            })]);
          },
          onOk: function onOk() {
            var _this = this;

            this.$Modal.remove();
          }
        };
        this.$Modal.success(config);
      }
    },

    /*showEditPassword() {
      const vm = this;
      let config = {
        closable: false,
        maskClosable: false,
        width: 500,
        loading: true,
        render: h => {
          return h("div", [
            h("h3", {
              style: {
                borderBottom: "1px solid #eee",
                marginBottom: "15px",
                padding: "0 0 10px 0"
              }
            }, "编辑密码"),
            h(editPassword, {
              ref: "showEditPassword",
              props: {
                $store: vm.$store
              }
            })
          ])
        },
        onOk:function () {
            console.error('未配置接口地址，请设置api地址');
            let data = this.$refs.showEditPassword.editPasswordForm,params = data;
            this.buttonLoading = false;
            let callback = res => {
              if(res.result === 0 ){
                this.$Message.success(res.errorMsg);
              }else {
                this.$Message.error(res.errorMsg);
              }
            };
            let fun = function(){
              vm.$store.dispatch("url", params).then(res => {
                callback(res);
              });
            };
            this.$refs.showEditPassword.handleSubmit(fun);
        },
        onCancel () {
         }
      };
      this.$Modal.confirm(config);
    },*/

    /**
     * 编辑密码
     */
    showEditPassword: function showEditPassword() {
      var _this4 = this;

      var vm = this;
      var config = {
        loading: true,
        width: 600,
        render: function render(h) {
          return h("div", [h("h4", {
            style: {
              marginBottom: "15px"
            }
          }, _this4.$t('base.changePass')), h(forgot, {
            ref: "forgotRef",
            props: {
              $store: _this4.$store,
              edit: true,
              _vm: vm
            }
          })]);
        },
        onOk: function onOk() {
          var _this5 = this;

          this.buttonLoading = false;
          var reg = this.$refs.forgotRef;

          var _reg$formMoblie = _objectSpread({}, reg.formMoblie),
              mobile = _reg$formMoblie.mobile,
              code = _reg$formMoblie.code,
              password = _reg$formMoblie.password,
              org_code = _reg$formMoblie.org_code;

          var emailData = reg.formEmail,
              nameType,
              sendtype;

          var params,
              callbak = function callbak(res) {
            var msg = res.errorMsg;

            if (res.result === 0) {
              _this5.$Message.success(msg);

              _this5.$Modal.remove();
            } else {
              _this5.$Message.error(msg);
            }
          };

          if (reg.nameTabs == "name1") {
            sendtype = 1;
            params = {
              mobile: mobile,
              code: code,
              password: password,
              sendtype: sendtype
            };
            nameType = "formMoblie";
          } else {
            sendtype = 2;
            params = {
              email: emailData.email,
              code: emailData.code,
              password: emailData.password,
              sendtype: sendtype
            };
            nameType = "formEmail";
          }

          var submit = function submit() {
            vm.handleForgot(params).then(function (res) {
              callbak(res);
            });
          };

          this.$refs.forgotRef.handleSubmit(nameType, submit);
        }
      };
      this.$Modal.confirm(config);
    },

    /**
     * 升级账号
     */
    upgradeUser: function upgradeUser() {
      var vm = this; //判断企业编码是否填写

      if (!this.userInfo.enterprise_code) {
        this.editEnterprise_code('');
      } else {
        if (this.userInfo.account_type === 1) {
          this.upgradeTitle = this.$t('base.updateAccount');
        } else if (this.userInfo.account_type === 2) {
          this.upgradeTitle = this.$t('base.ViewCorporateCertification');
        }

        this.$refs.upgradeUser.showModal(true);
      }
    },

    /**
     * 编辑账号
     */
    showEditUser: function showEditUser() {
      var _this6 = this;

      var vm = this;
      var config = {
        closable: false,
        maskClosable: false,
        width: 600,
        loading: true,
        render: function render(h) {
          return h("div", [h("h3", {
            style: {
              borderBottom: "1px solid #eee",
              marginBottom: "15px",
              padding: "0 0 10px 0"
            }
          }, _this6.$t('base.changeAccount')), h(editUser, {
            ref: "showEditUser",
            props: {
              name: vm.userInfo.admin_name,
              $store: vm.$store,
              _vm: vm
            }
          })]);
        },
        onOk: function onOk() {
          var _this7 = this;

          this.buttonLoading = false;
          var data = this.$refs.showEditUser.editUserForm,
              params = data;

          var callback = function callback(res) {
            if (res.result === 0) {
              _this7.$Message.success(res.errorMsg);

              _this7.$Modal.remove();
            } else {
              _this7.$Message.error(res.errorMsg);
            }
          };

          var fun = function fun() {
            vm.$store.dispatch("handleChangeaccount", params).then(function (res) {
              callback(res);
            });
          };

          this.$refs.showEditUser.handleSubmit(fun);
        },
        onCancel: function onCancel() {//this.$Message.info("关闭");
        }
      };
      this.$Modal.confirm(config);
    },
    getUserInfoFun: function getUserInfoFun() {
      var vm = this;
      /*this.$store.dispatch("getUserInfo").then(res => {
        if( res.result === 0 ){
          vm.userInfo = res.body;
        }else {
          this.$Message.error(res.errorMsg);
        }
      })*/

      var infoStore = deepcopy(vm.userInfoStore);

      if (infoStore.area == null) {
        infoStore.area = [];
      }

      ;
      vm.userInfo = infoStore;
    },

    /**
     *拉取区域
     */
    getProvince: function getProvince() {
      var parent_id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var vm = this;

      var params = {
        parent_id: parent_id,
        getAll: true
      },
          callback = function callback(res) {
        if (res.result === 0) {
          vm.handelData(res.body);
        } else {
          console.error(res.errorMsg);
        }
      };

      this.$store.dispatch('handleGetregion', params).then(function (res) {
        callback(res);
      });
    },
    handelData: function handelData(data) {
      var mangerCas = function mangerCas(item) {
        var tree = [];
        item.map(function (ite, index) {
          var obj = {
            label: ite.region_name,
            value: ite.code
          }; //只级一级国家
          // if(ite.children && ite.children.length != 'null' && ite.children.length > 0){
          //   obj.children = mangerCas(ite.children);
          // };

          tree.push(obj);
        }); //console.log(tree);

        return tree;
      };

      this.TreeData = mangerCas(data); //console.log(mangerCas(data));
    },
    //编辑地址
    editAddress: function editAddress(item) {
      var _this8 = this;

      var vm = this;
      this.$set(this.editMessage, 'address', item);
      var config = {
        loading: true,
        width: 400,
        render: function render(h) {
          return h('div', [h('h3', _this8.$t('base.editStreetAddress')), h('Divider'), h('div', [h('Input', {
            props: {
              value: _this8.editMessage.address,
              placeholder: _this8.$t('base.editStreetAddressplaceholder')
            },
            on: {
              input: function input(val) {
                _this8.editMessage.address = val;
              }
            }
          })])]);
        },
        onOk: function onOk() {
          var _this = this;

          if (vm.editMessage.address) {
            vm.$store.dispatch("handleSavebaseinfo", {
              address: vm.editMessage.address
            }).then(function (res) {
              _this.buttonLoading = false;
              var msg = res.errorMsg;

              if (res.result === 0) {
                vm.$Message.success(msg);
                vm.$Modal.remove();
                vm.init();
              } else {
                vm.$Message.error(msg);
              }
            });
          } else {
            _this.buttonLoading = false;
            vm.$Message.error(this.$t('base.editStreetAddressplaceholder'));
          }
        }
      };
      this.$Modal.confirm(config);
    },
    editEnterprise_code: function editEnterprise_code(item) {
      var _this9 = this;

      var vm = this;
      this.$set(this.editMessage, 'enterprise_code', item);
      var config = {
        loading: true,
        width: 400,
        render: function render(h) {
          return h('div', [h('h3', _this9.$t('base.enterpriseCode')), h('Divider'), h('div', [h('div', {
            style: {
              color: 'red',
              marginBottom: '8px'
            }
          }, _this9.$t('base.enterpriseCodeNotice')), h('Input', {
            props: {
              value: _this9.editMessage.enterprise_code,
              placeholder: _this9.$t('base.enterpriseCodeplaceholder'),
              maxlength: 6
            },
            on: {
              input: function input(val) {
                _this9.editMessage.enterprise_code = val;
              }
            }
          })])]);
        },
        onOk: function onOk() {
          var _this = this;

          if (vm.editMessage.enterprise_code) {
            var reg = /^[0-9A-Z]{6}$/;

            if (reg.test(vm.editMessage.enterprise_code)) {
              vm.$store.dispatch("handleSavebaseinfo", {
                enterprise_code: vm.editMessage.enterprise_code
              }).then(function (res) {
                _this.buttonLoading = false;
                var msg = res.errorMsg;

                if (res.result === 0) {
                  vm.$Message.success(msg);
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(msg);
                }
              });
            } else {
              _this.buttonLoading = false;
              vm.$Message.error(vm.$t('base.enterpriseCodeformat'));
            }
          } else {
            _this.buttonLoading = false;
            vm.$Message.error(vm.$t('base.enterpriseCodeplaceholder'));
          }
        }
      };
      this.$Modal.confirm(config);
    },
    //中文
    editEnterprise_name_cn: function editEnterprise_name_cn(item) {
      var _this10 = this;

      var vm = this;
      this.$set(this.editMessage, 'enterprise_name_cn', item);
      var config = {
        loading: true,
        width: 700,
        render: function render(h) {
          return h('div', [h('h3', _this10.$t('base.editcompanyNameCN')), h('Divider'), h('div', [h('div', {
            style: {
              color: 'red',
              marginBottom: '8px'
            }
          }, _this10.$t('base.companyNameCNNotice')), h('Input', {
            props: {
              value: _this10.editMessage.enterprise_name_cn,
              placeholder: _this10.$t('base.companyNameCNplaceholder')
            },
            on: {
              input: function input(val) {
                _this10.editMessage.enterprise_name_cn = val;
              }
            }
          }), h('img', {
            style: {
              width: '400px',
              marginTop: '8px'
            },
            attrs: {
              src: _this10.showqiyename
            }
          })])]);
        },
        onOk: function onOk() {
          var _this = this;

          if (vm.editMessage.enterprise_name_cn) {
            vm.$store.dispatch("handleSavebaseinfo", {
              enterprise_name_cn: vm.editMessage.enterprise_name_cn
            }).then(function (res) {
              _this.buttonLoading = false;
              var msg = res.errorMsg;

              if (res.result === 0) {
                vm.$Message.success(msg);
                vm.$Modal.remove();
                vm.init();
              } else {
                vm.$Message.error(msg);
              }
            });
          } else {
            _this.buttonLoading = false;
            vm.$Message.error(vm.$t('base.companyNameCNplaceholder'));
          }
        }
      };
      this.$Modal.confirm(config);
    },
    //英文
    editEnterprise_name_en: function editEnterprise_name_en(item) {
      var _this11 = this;

      var vm = this;
      this.$set(this.editMessage, 'enterprise_name_en', item);
      var config = {
        loading: true,
        width: 700,
        render: function render(h) {
          return h('div', [h('h3', _this11.$t('base.editcompanyNameUS')), h('Divider'), h('div', [h('div', {
            style: {
              color: 'red',
              marginBottom: '8px'
            }
          }, _this11.$t('base.companyNameCNNotice')), h('Input', {
            props: {
              value: _this11.editMessage.enterprise_name_en,
              placeholder: _this11.$t('base.companyNameUSplaceholder')
            },
            on: {
              input: function input(val) {
                _this11.editMessage.enterprise_name_en = val;
              }
            }
          }), h('img', {
            style: {
              width: '400px',
              marginTop: '8px'
            },
            attrs: {
              src: _this11.showqiyename
            }
          })])]);
        },
        onOk: function onOk() {
          var _this = this;

          if (vm.editMessage.enterprise_name_en) {
            vm.$store.dispatch("handleSavebaseinfo", {
              enterprise_name_en: vm.editMessage.enterprise_name_en
            }).then(function (res) {
              _this.buttonLoading = false;
              var msg = res.errorMsg;

              if (res.result === 0) {
                vm.$Message.success(msg);
                vm.$Modal.remove();
                vm.init();
              } else {
                vm.$Message.error(msg);
              }
            });
          } else {
            _this.buttonLoading = false;
            vm.$Message.error(vm.$t('base.companyNameUSplaceholder'));
          }
        }
      };
      this.$Modal.confirm(config);
    },
    editMobile: function editMobile(item) {
      var _this12 = this;

      var vm = this;
      this.$set(this.editMessage, 'mobile_phone', item);
      var config = {
        loading: true,
        width: 400,
        render: function render(h) {
          return h('div', [h('h3', _this12.$t('base.editcontactNumber')), h('Divider'), h('div', [h('Input', {
            props: {
              value: _this12.editMessage.mobile_phone,
              placeholder: _this12.$t('base.contactNumberplaceholder')
            },
            on: {
              input: function input(val) {
                _this12.editMessage.mobile_phone = val;
              }
            }
          })])]);
        },
        onOk: function onOk() {
          var _this = this;

          var regemail = /^1[0-9]{10}$/;

          if (vm.editMessage.mobile_phone) {
            if (regemail.test(vm.editMessage.mobile_phone)) {
              vm.$store.dispatch("handleSavebaseinfo", {
                mobile_phone: vm.editMessage.mobile_phone
              }).then(function (res) {
                _this.buttonLoading = false;
                var msg = res.errorMsg;

                if (res.result === 0) {
                  vm.$Message.success(msg);
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(msg);
                }
              });
            } else {
              _this.buttonLoading = false;
              vm.$Message.error(vm.$t('base.contactNumbernotice'));
            }
          } else {
            _this.buttonLoading = false;
            vm.$Message.error(vm.$t('base.contactNumberplaceholder'));
          }
        }
      };
      this.$Modal.confirm(config);
    },
    editEmail: function editEmail(item) {
      var _this13 = this;

      var vm = this;
      this.$set(this.editMessage, 'email', item);
      var config = {
        loading: true,
        width: 400,
        render: function render(h) {
          return h('div', [h('h3', _this13.$t('base.editemail')), h('Divider'), h('div', [h('Input', {
            props: {
              value: _this13.editMessage.email,
              placeholder: _this13.$t('base.emailplaceholder')
            },
            on: {
              input: function input(val) {
                _this13.editMessage.email = val;
              }
            }
          })])]);
        },
        onOk: function onOk() {
          var _this = this;

          var regemail = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;

          if (vm.editMessage.email) {
            if (regemail.test(vm.editMessage.email)) {
              vm.$store.dispatch("handleSavebaseinfo", {
                email: vm.editMessage.email
              }).then(function (res) {
                _this.buttonLoading = false;
                var msg = res.errorMsg;

                if (res.result === 0) {
                  vm.$Message.success(msg);
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(msg);
                }
              });
            } else {
              vm.$Message.error(vm.$t('base.emailFormat'));
              _this.buttonLoading = false;
            }
          } else {
            _this.buttonLoading = false;
            vm.$Message.error(vm.$t('base.emailplaceholder'));
          }
        }
      };
      this.$Modal.confirm(config);
    },
    editArea: function editArea(item) {
      var _this14 = this;

      var vm = this;
      this.$set(this.editMessage, 'area', item);
      var config = {
        loading: true,
        width: 400,
        render: function render(h) {
          return h('div', [h('h3', _this14.$t('base.selectArea')), h('Divider'), h('div', [h('Cascader', {
            props: {
              data: _this14.TreeData,
              value: _this14.editMessage.area,
              placeholder: _this14.$t('base.selectAreaplaceholder')
            },
            on: {
              'on-change': function onChange(val) {
                _this14.editMessage.area = val;
              }
            }
          })])]);
        },
        onOk: function onOk() {
          var _this = this;

          if (vm.editMessage.area) {
            vm.$store.dispatch("handleSavebaseinfo", {
              area: vm.editMessage.area
            }).then(function (res) {
              _this.buttonLoading = false;
              var msg = res.errorMsg;

              if (res.result === 0) {
                vm.$Message.success(msg);
                vm.$Modal.remove();
                vm.init();
              } else {
                vm.$Message.error(msg);
              }
            });
          } else {
            _this.buttonLoading = false;
            vm.$Message.error(vm.$t('base.selectAreaplaceholder'));
          }
        }
      };
      this.$Modal.confirm(config);
    },
    init: function init() {
      var _this15 = this;

      this.$store.dispatch('getUserInfo').then(function (res) {
        if (res.result === 0) {
          Object.assign(_this15.userInfo, res.body);
        }
      });
    },
    fliterType: function fliterType(val) {
      switch (val) {
        case 1:
          return this.$t('base.personalAccount');

        case 2:
          return this.$t('base.companyAccount');

        default:
          break;
      }
    }
  }),
  mounted: function mounted() {
    this.getUserInfoFun();
    this.getProvince();
  },
  computed: {
    userInfoStore: function userInfoStore() {
      return this.$store.state.user.userInfo;
    },
    extensionNumber: function extensionNumber() {
      if (this.$store.state.user.userInfo.callCenterQueue && this.$store.state.user.userInfo.callCenterQueue.extensionNumber) {
        return this.$store.state.user.userInfo.callCenterQueue.extensionNumber;
      }

      return "";
    }
  },
  filters: {
    authentication: function authentication(val) {
      switch (val) {
        case 0:
          return this.$t('base.Unnamed');

        case 1:
          return this.$t('base.realName');

        case 2:
          return this.$t('base.underReview');

        default:
          break;
      }
    }
  },
  components: {
    editUser: editUser,
    upgradeUser: upgradeUser
  }
};